import React, { useEffect, useState, useMemo } from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import ModalMensaje from "../general/ModalMensaje";
import { Toast,ToastContainer } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Unauthorized from "../general/Unauthorized";

function Usuarios() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [username, setUsername] = useState('');
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [estadoModal, setEstadomodal] = useState('hidden');
    const [mensajeNuevoUsuario, setMensajeNuevoUsuario] = useState('');
    let userdata = [];
    let nuevoUsuario = '';
    let clientData = [];

    const [terminoBusqueda, setTerminoBusqueda] = useState('');

    const [toastMsg, setToastMsg] = useState('');
    const [showToast, setShowToast] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    
    const cols = [
        { 
            name: 'Nombre', 
            cell: row => (
                <span title={`${row.name} ${row.lastname}`}>
                    {row.name} {row.lastname}
                </span>
            ),
            sortable: true 
        },
        { 
            name: 'Cargo', 
            cell: row => (
                <span title={row.cargo || 'Sin cargo'}>
                    {row.cargo || '-'}
                </span>
            )
        },
        { 
            name: 'Documento', 
            cell: row => (
                <span title={`${row.tipo_documento} ${row.numero_documento}`}>
                    {row.tipo_documento} {row.numero_documento}
                </span>
            ),
            sortable: true 
        },
        { 
            name: 'Email', 
            cell: row => (
                <span title={row.email}>
                    {row.email}
                </span>
            ),
            sortable: false 
        },
        { 
            name: 'Celular', 
            cell: row => (
                <span title={row.celular || 'Sin celular'}>
                    {row.celular || '-'}
                </span>
            ),
            sortable: false 
        },
        { 
            name: 'Acción', 
            cell: row => getBotones(row),
            grow: 0,
            minWidth: '58px',
            width: '110px',
            center: true,
            ignoreRowClick: true,
        }
    ];

    const getBotones = (item) => (
        <Link
            to={'/editar-usuario?id=' + item.id}
            className="btn btn-sm btn-info text-white font-weight-bold d-inline-flex align-items-center justify-content-center text-nowrap"
            style={{ borderRadius: '8px', padding: '6px 9px' }}
            title="Editar usuario"
            aria-label="Editar usuario"
        >
            <i className="far fa-edit" style={{ fontSize: '1rem' }} aria-hidden="true"></i>
            <span className="d-none d-md-inline ml-md-1">Editar</span>
        </Link>
    );

    const customTableStyles = useMemo(() => ({
        table: { style: { backgroundColor: '#fff' } },
        headRow: {
            style: {
                minHeight: '44px',
                borderBottom: '1px solid #e9eef3',
                backgroundColor: '#f8f9fa',
            },
        },
        headCells: {
            style: {
                fontSize: '0.7rem',
                fontWeight: 700,
                color: '#7d7d7d',
                textTransform: 'uppercase',
                letterSpacing: '0.45px',
                paddingTop: '12px',
                paddingBottom: '12px',
                paddingLeft: '15px',
                paddingRight: '15px',
            },
        },
        rows: {
            style: {
                minHeight: '48px',
                borderBottom: '1px solid #f0f0f0',
                fontSize: '13px',
            },
            highlightOnHoverStyle: {
                backgroundColor: '#f9fbff',
                borderBottomColor: '#e9eef3',
                boxShadow: 'inset 4px 0 0 #17a2b8',
            },
        },
        cells: {
            style: {
                paddingTop: '10px',
                paddingBottom: '10px',
                paddingLeft: '15px',
                paddingRight: '15px',
                color: '#323a45',
            },
        },
        pagination: {
            style: {
                borderTop: '1px solid #eef0f2',
                minHeight: '52px',
                fontSize: '13px',
                color: '#6c757d',
            },
        },
    }), []);

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔒 VALIDACIÓN DE PERMISOS - Verificar acceso a gestión de personal (con fallback)
        let tienePermiso = false;
        
        // Intentar con el sistema nuevo
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            tienePermiso = userdata.permissions.some(permission => permission.slug === 'gestionPersonal');
        }
        // Fallback al sistema antiguo
        else if (userdata.up && userdata.up.includes('gestionPersonal')) {
            tienePermiso = true;
        }
        
        if (!tienePermiso) {
            setHasPermission(false);
            return; // Detener ejecución si no tiene permisos
        }

        setHasPermission(true);

        /*if (localStorage.getItem('nuevo_usuario')) {
            nuevoUsuario = localStorage.getItem('nuevo_usuario');

            setEstadomodal('visible');
            setMensajeNuevoUsuario('Se ha enviado un mensaje a '+nuevoUsuario+' con la información necesaria para activar su cuenta.');

            localStorage.removeItem('nuevo_usuario');
        }*/

        if (localStorage.getItem('edit_usuario')) {
            setToastMsg('El usuario '+localStorage.getItem('edit_usuario')+' ha sido modificado');
            localStorage.removeItem('edit_usuario');
            setTimeout(() => { setShowToast(true) },800);
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        // Cargar información del cliente
        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    setUsername(userdata.user_name);
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error cargando cliente:', error);
            });

        // Cargar usuarios - SIN parámetro uid (se extrae del token JWT)
        setLoading(true);
        axios.get('/usuarios', config)
            .then(response => {
                if (response.status===200) {
                    setItems(response.data);
                    setLoggedIn(true);
                    setLoading(false);
                }
            })
            .catch(error => {
                console.error('Error cargando usuarios:', error);
                setError(error.response?.data || error.message);
                setLoading(false);
            });
    },[]);


    useEffect(() => {
        
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                termino: terminoBusqueda
            }
        }

        // Buscar usuarios - SIN parámetro uid (se extrae del token JWT)
        axios.get('/usuarios', config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.error('Error en búsqueda de usuarios:', error);
            })

    },[terminoBusqueda]);



    // 🔒 PROTECCIÓN DE RUTA - Si no tiene permisos, mostrar página de acceso denegado
    if (hasPermission === false) {
        return <Unauthorized />;
    }

    const errorMensaje = error
        ? (typeof error === 'string' ? error : (error?.message || 'No se pudo cargar el listado. Intente de nuevo.'))
        : '';

    if (loggedIn) {
        return (
            
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <style>{`
                    .usuarios-filter-card {
                        background: #fff;
                        border-radius: 12px;
                        border: none;
                        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.05);
                        padding: 1.25rem 1.35rem;
                        margin-bottom: 1.25rem;
                    }
                    .usuarios-table-card {
                        border-radius: 16px;
                        overflow: hidden;
                        box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
                        border: none !important;
                    }
                    .usuarios-table-card .rdt_Table,
                    .usuarios-table-card .rdt_TableWrapper {
                        border-radius: 0;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/personal-proveedores">Administrador de Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item active" key="bc4">Personal y Profesionales</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-center">
                                <div className="col-md-8">
                                    <h1 className="m-0" style={{ fontWeight: 700, fontSize: '1.5rem', color: '#323a45' }}>Personal y Profesionales</h1>
                                    <p className="mb-0 mt-1 text-muted" style={{ fontSize: '0.8rem' }}>
                                        <span className="badge" style={{ background: 'rgba(23,162,184,0.1)', color: '#117f90', border: '1px solid rgba(23,162,184,0.2)', borderRadius: '999px', fontWeight: 700, fontSize: '0.72rem' }}>
                                            {items.length} registros
                                        </span>
                                    </p>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/nuevo-usuario" className="btn btn-primary font-weight-bold" style={{ borderRadius: '10px', padding: '8px 18px', fontSize: '0.9rem' }}>
                                        <i className="fas fa-user-plus mr-2"></i>
                                        Nuevo personal
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                        <div className="usuarios-filter-card">
                            <div className="row align-items-end">
                                <div className="col-md-6 col-lg-4">
                                    <label htmlFor="terminoBusqueda" className="small font-weight-bold text-uppercase text-muted mb-1 d-block">Buscar</label>
                                    <input
                                        type="text"
                                        name="terminoBusqueda"
                                        className="form-control"
                                        id="terminoBusqueda"
                                        placeholder="Nombre, documento, email…"
                                        onChange={(e) => setTerminoBusqueda(e.target.value)}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12">
                                
                                {loading ? (
                                    <div className="card usuarios-table-card">
                                        <div className="card-body text-center py-5 text-muted">
                                            <div className="spinner-border text-info mb-3" role="status">
                                                <span className="sr-only">Cargando usuarios...</span>
                                            </div>
                                            <p className="mb-0">Cargando usuarios…</p>
                                        </div>
                                    </div>
                                ) : error ? (
                                    <div className="alert alert-danger border-0 shadow-sm" style={{ borderRadius: '12px' }}>
                                        <strong>Error al cargar usuarios</strong>
                                        <p className="mb-0 mt-2 small">{errorMensaje}</p>
                                    </div>
                                ) : (
                                    <div className="card usuarios-table-card bg-white">
                                        <DataTable
                                            columns={cols}
                                            data={items}
                                            customStyles={customTableStyles}
                                            highlightOnHover
                                            pointerOnHover
                                            pagination
                                            paginationComponentOptions={{
                                                rowsPerPageText: 'Filas por página:',
                                                rangeSeparatorText: 'de',
                                                noRowsPerPage: false,
                                                selectAllRowsItem: true,
                                                selectAllRowsItemText: 'Todos',
                                            }}
                                            noDataComponent={
                                                <div className="text-muted py-5">No hay registros para mostrar</div>
                                            }
                                            id="usuarios"
                                        />
                                    </div>
                                )}

                            </div>          
                        </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} message={toastMsg} />

                <ToastContainer className="toast-exito">
                    <Toast onClose={() => setShowToast(false)} show={showToast} delay={4000} autohide>
                        <Toast.Body>{toastMsg}</Toast.Body>
                    </Toast>
                </ToastContainer>


                <ModalMensaje mensaje={mensajeNuevoUsuario} estadoInicial={estadoModal} accion={null} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default Usuarios;